// extracted by mini-css-extract-plugin
export default {"container":"MenuDrawer_container__cLJuj"};